import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Observable, takeUntil } from 'rxjs';
import { VisitorPlace } from '../../models/visitor.place';
import { VisitorPlaceService } from 'src/app/modules/event-calendar/services/visitor.place.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { ModalService } from 'src/app/common/services/modal/modal.service';
import { FancyPlaceDetailsModalComponent } from 'src/app/modules/place-calendar/components/place.details.modal/fancy.place.details.modal/fancy.place.details.modal.component';
import { IPlaceDetailsModalData } from 'src/app/modules/place-calendar/components/place.details.modal/place.details.modal.provider';
import { IAppState } from '../../ngrx.stores/frontend.settings/states';
import { Store, select } from '@ngrx/store';
import { SubscriptionDisposable } from 'src/app/common/SubscriptionDisposable';
import { placeQueryCommandSelector } from 'src/app/modules/place-calendar/ngrx.stores/place.query.command/selectors';
import { PlaceStore } from 'src/app/modules/place-calendar/ngrx.stores/place.query.command/stores';

@Component({
  selector: 'ig-nearby-places',
  templateUrl: './nearby.places.component.html',
  styleUrls: ['./nearby.places.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NearbyPlacesComponent
  extends SubscriptionDisposable
  implements OnInit
{
  // nearByPlaces$: Observable<VisitorPlace[] | null>;

  @Input() place: VisitorPlace;
  @Input() from: 'event' | 'place';
  @Input() range: number = 2;
  nearByPlaces$: Observable<VisitorPlace[] | null>;
  categoryList: string[] = []; // for custom category, which is usually a recursive PlaceType object, and will be extracted all sub categories into this list
  category: string = ''; // for ImGoing default category, which is a string and send to server side to get the allowed categories

  isAtEnd = false;
  isAtStart = true;

  @ViewChild(MatMenuTrigger, { static: false })
  matMenuTrigger: MatMenuTrigger;
  @ViewChild('nearbyPlacesContainer', { static: false })
  nearbyPlacesContainer: ElementRef;
  @ViewChild('card', { static: false }) card: ElementRef;

  @Output() public rangeChanged = new EventEmitter<number>();

  constructor(
    public placeService: VisitorPlaceService,
    public modalService: ModalService,
    public _store: Store<IAppState>
  ) {
    super();
  }

  ngOnInit(): void {
    this.nearByPlaces$ = this.loadNearbyPlaces();

    // show default title in the custom default place category dropdown in nearby component
    PlaceStore.customDefaultCategoryStore.next({
      title: '',
      from: 'nearbyPlaces',
    });

    // have no idea why the custom default place category dispatch doesn't work in event details page's nearby places component
    // here we manually subscribe to the store
    PlaceStore.customDefaultCategoryStore
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((cmd) => {
        if (!cmd) return;

        this.category = cmd.category;
        this.categoryList = cmd.categoryList;
        this.nearByPlaces$ = this.loadNearbyPlaces();
        this.isAtEnd = false;
        this.isAtStart = true;
        this.matMenuTrigger?.closeMenu();
        this.rangeChanged.emit(this.range);
      });
  }

  loadNearbyPlaces() {
    return this.placeService.getNearByPlaces(
      this.place,
      this.range,
      this.category,
      this.categoryList
    );
  }

  setRange(range: number) {
    this.range = range;
    this.nearByPlaces$ = this.loadNearbyPlaces();
    this.isAtEnd = false;
    this.isAtStart = true;
    this.matMenuTrigger?.closeMenu();
    this.rangeChanged.emit(range);
  }

  goToPlace(place: VisitorPlace) {
    this.modalService.show({
      component: FancyPlaceDetailsModalComponent,
      panelClass: 'ig-modal-w-full',
      data: {
        currentPlace: place,
        from: this.from === 'event' ? 'nearbyOnEvent' : 'nearbyOnPlace',
      } as IPlaceDetailsModalData,
    });
  }

  goRight() {
    this.nearbyPlacesContainer.nativeElement.scrollLeft +=
      this.getPlaceScrollWidth();

    this.checkIsAtStart();
    this.checkIsAtEnd();
  }

  goLeft() {
    this.nearbyPlacesContainer.nativeElement.scrollLeft -=
      this.getPlaceScrollWidth();

    this.checkIsAtStart();
    this.checkIsAtEnd();
  }

  getPlaceScrollWidth() {
    return (
      this.nearbyPlacesContainer.nativeElement.getBoundingClientRect().width + 8
    );
  }

  checkIsAtStart() {
    if (this.nearbyPlacesContainer) {
      setTimeout(() => {
        const { scrollLeft } = this.nearbyPlacesContainer.nativeElement;
        this.isAtStart = scrollLeft === 0;
      }, 800);
    }
  }

  checkIsAtEnd() {
    if (this.nearbyPlacesContainer) {
      setTimeout(() => {
        const { scrollWidth, scrollLeft, clientWidth } =
          this.nearbyPlacesContainer.nativeElement;

        this.isAtEnd = scrollWidth - (scrollLeft + clientWidth) <= 10;
      }, 800);
    }
  }

  getDisplayCategory(place: VisitorPlace) {
    return this.placeService.getDisplayCategory(place);
  }
}
